module.exports = __webpack_public_path__ + "static/media/Lato-Black.e631d273.ttf";